import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';

import { RIGHT_TO_LEFT_LOCALES } from '../../../utils/constants';
import { StoreHeader, TransactionTimeAndPlace } from '../../reusable/ej-view-sections';
import Footer from '../../reusable/ej-view-sections/Footer';

const NoSaleView = ({
  locale, storeHeaderInfo, timezone, transaction, footers
}) => {
    const { RL_DUPLICATERECEIPT } = useSelector((state) => state);
    const isRightToLeft = RIGHT_TO_LEFT_LOCALES.includes(locale.localeName) ? 'RTL' : 'LTR';
   return (
     <section
       className="p2-sm body-4 display-print"
       style={{
      direction: isRightToLeft,
  }}
     >
       <br />
       <StoreHeader
         address={storeHeaderInfo.address}
         locale={locale}
         localizations={storeHeaderInfo.localizations}
         locationCode={transaction.BusinessUnit?.LocationCode}
         name={storeHeaderInfo.name}
         phoneNumber={storeHeaderInfo.phoneNumber}
         storeConcept={storeHeaderInfo.storeConcept}
         trainingMode={transaction.TrainingModeFlag}
         transaction={transaction}
       />
       <p style={{ fontSize: '16px' }}>{`***${RL_DUPLICATERECEIPT}***`}</p>
       <article className="body-4 ta-sm-c justify-between">
         <p className="pl4-sm">Reason : {transaction.ControlTransaction?.Reason?.Description ?? ''}</p>
       </article>
       <br /><br />
       <TransactionTimeAndPlace
         date={transaction.BusinessDayDate}
         locale={locale}
         operator={transaction.Operator?.ID}
         register={transaction.ControlTransaction?.NoSale?.CashDrawerID}
         store={transaction.BusinessUnit?.LocationCode}
         suspendedTransactionReference={transaction?.SuspendedTransactionReference}
         time={transaction.BeginDateTime}
         timezone={timezone}
         transaction={transaction.SequenceNumber}
       />
       <Footer footers={footers} />
     </section>
);
};

NoSaleView.defaultProps = {
  footers: [],
  locale: {},
  storeHeaderInfo: {},
  timezone: '',
  transaction: {}
};

NoSaleView.propTypes = {
  footers: PropTypes.arrayOf(PropTypes.string),
  locale: PropTypes.shape(),
  storeHeaderInfo: PropTypes.shape(),
  timezone: PropTypes.string,
  transaction: PropTypes.shape(),
};

export default NoSaleView;
